import { IconObject, IconType } from '@components/Icon';

export const ExpLanguage: IconObject[][] = [
  [
    { iconType: IconType.Go },
    { iconType: IconType.Java },
    { iconType: IconType.Python },
    { iconType: IconType.JavaScript },
    { iconType: IconType.TypeScript },
  ],
  [{ iconType: IconType.Thrift }],
];
export const FamLanguage: IconObject[][] = [
  [
    { iconType: IconType.Swift },
    { iconType: IconType.R },
    { iconType: IconType.Elixir },
    { iconType: IconType.Erlang },
    { iconType: IconType.AutoIt },
  ],
  [{ iconType: IconType.Ruby }],
];

export const ExpTech: IconObject[][] = [
  [
    { iconType: IconType.Redux },
    { iconType: IconType.React },
    { iconType: IconType.NextJs },
    { iconType: IconType.NodeJs },
    { iconType: IconType.Ionic },
  ],
  [
    { iconType: IconType.PostgreSql },
    { iconType: IconType.MySql },
    { iconType: IconType.Kafka },
    { iconType: IconType.Grpc },
    { iconType: IconType.Tailwind },
  ],
  [
    { iconType: IconType.MaterialUI },
    { iconType: IconType.BlueprintJs },
    { iconType: IconType.Sequelize },
    { iconType: IconType.ExpressJs },
    { iconType: IconType.Recoil },
  ],
  [{ iconType: IconType.Storybook }, { iconType: IconType.Rails }, { iconType: IconType.JQuery }, { iconType: IconType.Git }],
];
export const FamTech: IconObject[][] = [
  [{ iconType: IconType.AwsApiGateway }, { iconType: IconType.AwsDynamoDb }, { iconType: IconType.AwsLambda }, { iconType: IconType.Ecto }],
];
